import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import { BarChart2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Surveys = () => {
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const res = await axios.get(`${apiurl}/api/survey/get`);
        if (res.data.success) {
          setSurveys(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching surveys:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSurveys();
  }, []);

  if (loading)
    return (
      <div className="p-6 text-center text-gray-600">
        Loading surveys...
      </div>
    );

  return (
    <Layout>
      <Container overflow="overflow-scroll">
        <div className="min-h-screen bg-gray-50 p-6">
          <div className="max-w-6xl mx-auto">
            {/* Header */}
            <div className="mb-10 text-center">
              <h1 className="text-4xl font-bold text-gray-900">Surveys</h1>
              <p className="text-gray-600 mt-2">
                View all surveys and their reports.
              </p>
            </div>

            {/* Survey List */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {surveys.length === 0 && (
                <p className="text-gray-500 col-span-full text-center">
                  No surveys available
                </p>
              )}
              {surveys.map((survey) => (
                <div
                  key={survey.id}
                  className="bg-white shadow-lg rounded-xl p-6 flex flex-col justify-between hover:shadow-2xl transition-shadow border-l-4 border-yellow-400"
                >
                  <div>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">
                      {survey.title}
                    </h2>
                    <p className="text-gray-500 text-sm mb-4">
                      {survey.description}
                    </p>
                    <p className="text-gray-600 text-sm">
                      Created By:{" "}
                      <span className="font-medium">{survey.createdBy.userName}</span>
                    </p>
                  </div>

                  <div className="mt-4 flex justify-between items-center">
                    <span className="text-gray-500 text-sm">
                      {survey.questions.length} Questions
                    </span>
                    <button
                      onClick={() => navigate(`/surveys/${survey.id}/report`)}
                      className="flex items-center gap-2 px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold rounded-xl shadow-md transition-all"
                    >
                      <BarChart2 size={18} /> View Report
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default Surveys;